"use client"

import { useIsDesktop } from "@/ui/common/bit/MediaQueries"
import styled from "@emotion/styled"
import { Box } from "@mui/material"
import dynamic from "next/dynamic"
import { InvestmentGraphProps } from "./types"

// Dynamic import for ApexCharts to avoid SSR issues
const Chart = dynamic(() => import("react-apexcharts"), { ssr: false })

const StyledChartContainer = styled(Box)`
  width: 100%;
  /* max-width: 466px; */
`

const InvestmentGraph = ({
  chartOptions,
  chartSeries,
  fullWidth,
}: InvestmentGraphProps) => {
  const isDesktop = useIsDesktop()
  const chartHeight = fullWidth && isDesktop ? 250 : 158
  return (
    <StyledChartContainer>
      <Chart
        options={chartOptions}
        series={chartSeries}
        type="area"
        height={chartHeight}
      />
    </StyledChartContainer>
  )
}

export default InvestmentGraph
